export function flagEmoji(code: string): string {
  if (code === 'GLOBAL') return '🌍';
  return [...code.toUpperCase()]
    .map(c => String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65))
    .join('');
}
